<template>
    <div class="home-container">
        <div class="left-container">
            <div class="parent-tip">
                <div style="position: relative;background: #bd5959;color:#FFFFFF;padding: 3px 10px;" :style="menu.menuEntities.length==0?'cursor: pointer;':''" @click="firshow(menu.id,menu.memo,-1)">
                    <!-- <img class="arrow-img none" id="img0" src="../../assets/jdprotal/arrow.png" alt=""> -->
                    {{menu.name}}
                </div>
            </div>
            <div class="child-tip" v-for="(item,index) in menu.menuEntities" :key="index">
                <div style="position: relative;cursor: pointer;" @click="showInfo1(item.id,item.memo,index)">
                    <img :class="index==0&&menu.memo!=1?'arrow-img':'arrow-img none'" :id="'img'+(index+1)" style="top:0" src="../../assets/jdprotal/arrow.png" alt="">
                    {{item.name}}
                </div>
            </div>
        </div>
        <div class="divider-line"></div>
        <div style="width:calc(100% - 244px)" :class="memo!='1'?'':'none'" >
            <div style="padding:30px 60px 0">
                <div class="title">{{info.title}}</div>
                <div ref="innerHtml" style="margin-top:30px">

                </div>
            </div>
            
        </div>
        <div style="width:calc(100% - 270px);padding:40px 60px 0;"  :class="memo=='1'?'':'none'" >
            <div style="min-height: calc(100% - 82px);">
                <div class="news-units" v-for="(item,index) in newList" :key="index" @click="toDetail(item,item.id)">
                    <div style="padding: 0;">
                        <div class="news-top">
                            <div>{{item.title | ellipsis2}}</div>
                            <div style="font-size:16px">{{item.createDate | datetime}}</div>
                        </div>
                        <!-- <div class="news-summary">{{item.summary | ellipsis}}</div> -->
                    </div>
                </div>
            </div>
            <el-pagination
                v-if="newList.length>0"
                class="msg-pagination-container"
                style="margin-top:44px"
                background
                layout="prev, pager, next"
                :total="count"
                :page-size="pageSize"
                :current-page.sync='currentPage'
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {  get,post } from "@/api/common/index";
export default {
    data(){
        return{
            id:null,
            menuList:[],
            menu:{
                menuEntities:[],
            },
            info:{
                title:null,
            },
            pageSize:15,
            pageIndex:0,
            newList:[],
            memo:null,
            codeID:null,
            count:0,
            currentPage:1,
            newsID:null,
        }
    },
    methods:{
        getInfo(){
            var memo1 = null
            var id1 = null
            var that = this
            if(this.menu.menuEntities.length>0){
                if(this.$route.query.tipIndex){
                    memo1 = this.menu.menuEntities[this.$route.query.tipIndex].memo
                    id1 = this.menu.menuEntities[this.$route.query.tipIndex].id
                    setTimeout(function () {
                        that.showInfo(id1,memo1,that.$route.query.tipIndex)
                    },30)
                }else{
                    memo1 = this.menu.menuEntities[0].memo
                    id1 = this.menu.menuEntities[0].id
                    setTimeout(function () {
                        that.showInfo(id1,memo1,0)
                    },30)
                }
            }else{
                memo1 = this.menu.memo
                id1 = this.menu.id
                setTimeout(function () {
                    that.showInfo(id1,memo1,-1)
                },30)
            }
            this.memo = memo1
            this.codeID = id1
        },
        getNewInfo(memo,id){
            get('/api/website/get_news_info',{memo:memo,id:id}).then(res => {
                if (res.success) {
                    this.$refs.innerHtml.innerHTML = res.data.content
                    this.info = res.data
                    post('/api/website/update_news_info?newsID='+this.info.newsID).then(res => {
                        if (res.success) {
                            
                        }
                    }, error => {
                        this.$message({
                            message: error,
                            type: "error",
                        });
                    })
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getNewsList(){
            get('/api/website/get_news_list',{codeID:this.codeID,pageSize:this.pageSize,pageIndex:this.pageIndex}).then(res => {
                if (res.success) {
                    this.newList = res.data
                    this.count = res.count
                    this.currentPage = this.pageIndex+1
                    if(this.$route.query.newsIndex){
                        for(var i = 0;i<this.newList.length;i++){
                            if(this.$route.query.newsIndex==this.newList[i].id){
                                this.memo = '0'
                                var item = this.newList[i]
                                this.$refs.innerHtml.innerHTML = item.content
                                this.info = item
                                this.newsID = null
                                return
                            }
                        }
                        if((this.pageIndex+1)*this.pageSize>=this.count){
                            return
                        }else{
                            this.pageIndex++
                            this.getNewsList()
                        }
                    }
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getMenuList(){
            get('/api/website/get_menu_list').then(res => {
                if (res.success) {
                    this.menuList = res.data
                    for(var i = 0;i<this.menuList.length;i++){
                        if(this.menuList[i].id==this.id){
                            this.menu = this.menuList[i]
                            this.getInfo()
                            break
                        }
                    }
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        showInfo1(id,memo,index){
            this.$router.push({path:'/InfoList',query:{id:this.id,index:this.$route.query.index,tipIndex:index}})
            this.showInfo(id,memo,index)
        },
        showInfo(id,memo,index){
            for(var i = 0;i<document.getElementsByClassName('arrow-img').length;i++){
                document.getElementsByClassName('arrow-img')[i].setAttribute('class','arrow-img none')
            }
            if(parseInt(index)>=0){
                document.getElementById('img'+(parseInt(index)+1)).setAttribute('class','arrow-img')
            }
            this.memo = memo
            
            if(memo=='0'){
                this.getNewInfo(memo,id)
            }else if(memo=='1'){
                if(this.codeID!=id){
                    this.currentPage = 1
                    this.pageIndex = 0
                }
                this.codeID = id
                if(this.$route.query.newsIndex){
                    this.currentPage = 1
                    this.pageIndex = 0
                    this.getNewsList()
                }else{
                    this.getNewsList()
                }
            }
            
        },
        toDetail(item,index){
            if(item.linkUrl){
                let a = document.createElement('a')
                a.setAttribute('target','view_window')
                a.href = item.linkUrl
                a.click()
                return
            }
            this.memo = '0'
            this.$refs.innerHtml.innerHTML = item.content
            this.info = item
            this.$router.push({path:'/InfoList',query:{id:this.id,index:this.$route.query.index,tipIndex:this.$route.query.tipIndex,newsIndex:index}})
            post('/api/website/update_news_info?newsID='+item.newsID).then(res => {
                if (res.success) {
                    
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        handleCurrentChange(val){
            this.pageIndex = val-1
            this.getNewsList()
            document.documentElement.scrollTop = 0
        },
        firshow(id,memo,index){
            if(this.menu.menuEntities.length==0){
                this.$router.push({path:'/InfoList',query:{id:this.id,index:this.$route.query.index}})
                this.showInfo(id,memo,index)
            }
        }
    },
    mounted(){
        this.id = this.$route.query.id
        this.getMenuList()
    },
    watch:{
        $route(to,from){
            if(this.id!=this.$route.query.id){
                for(var i = 0;i<document.getElementsByClassName('arrow-img').length;i++){
                    document.getElementsByClassName('arrow-img')[i].setAttribute('class','arrow-img none')
                }
                this.currentPage = 1
                this.pageIndex = 0
                this.id = this.$route.query.id
                this.getMenuList()
            }
        }
    },
    filters: {
        ellipsis (value) {
            if(value){
                if (value.length > 140) {
                    return value.slice(0,140) + '...'
                }
            }
            return value
        },
        ellipsis2 (value) {
            if(value){
                if (value.length > 40) {
                    return value.slice(0,40) + '...'
                }
            }
            return value
        },
    },
}
</script>

<style scoped>
.level{
    display: flex;
    align-items: center;
}
.home-container{
    width: 1298px;
    padding-top: 15px;
    padding-bottom: 25px;
    margin: 0 auto;
    display: flex;
}
.left-container{
    width: 240px;
    text-align: center;
}
.parent-tip{
    font-size: 22px;
    color: #444444;
    padding: 10px 0;
    display: flex;
    justify-content: center;
}
.child-tip{
    font-size: 18px;
    color: #444444;
    padding: 10px 0;
    display: flex;
    justify-content: center;
}
.divider-line{
    width: 4px;
    background: #CDCDCD;
    min-height: 700px;
}
.arrow-img{
    position: absolute;
    top: 1.5px;
    left: -34px;
}
.none{
    display: none;
}
.title{
    font-size: 30px;
    font-weight: bold;
    text-align: center;
}
.news-units{
    width: 100%;
    background: #FFFFFF;
    margin-bottom: 18px;
    cursor: pointer;
    color: #333333;
}
.news-units:hover{
    background: #FFFFFF;
    color: red;
}
.news-top{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    font-size: 18px;
    
}
.news-summary{
    font-size: 12px;
    color: #9D9D9D;
    line-height: 27px;
    margin-top: 12px;
}

/deep/ .el-pagination.is-background .el-pager li {
    /*对页数的样式进行修改*/
    background-color: #FFFFFF;
    color: #9AA5C3;
    border: 1px solid #9AA5C3;
}
/deep/ .el-pagination.is-background .btn-next {
    /*对下一页的按钮样式进行修改*/
    background-color: #FFFFFF;
    color: #9AA5C3;
    border: 1px solid #9AA5C3;
}
/deep/ .el-pagination.is-background .btn-prev {
    /*对上一页的按钮样式进行修改*/
    background-color: #FFFFFF;
    color: #9AA5C3;
    border: 1px solid #9AA5C3;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    /*当前选中页数的样式进行修改*/
    background-color: #F4F4F4;
    color: #CB1784;
    border: 1px solid #F4F4F4;
}
</style>